import { jsPDF } from "jspdf";
import axios from "axios";
import { message } from "antd";
import { MESSAGES, PDF_COLORS, PDF_FONTS, ROUTES } from '../constants/Constants';


const addWrappedText = (doc, text, xPos, yPos, maxWidth) => {
    const lines = doc.splitTextToSize(text, maxWidth);
    doc.text(lines, xPos, yPos);
    return yPos + (lines.length * 6); 
};

const generateEmptyPDF = () => {
    const doc = new jsPDF();
    
   
    doc.setFontSize(PDF_FONTS.HEADER);
    doc.setTextColor(...PDF_COLORS.HEADER_TEXT);
    doc.setFillColor(...PDF_COLORS.HEADER_BACKGROUND);
    doc.rect(0, 0, doc.internal.pageSize.width, 30, 'F');
    doc.text("Supplier Goals", 10, 20);
 
    let yPos = 50;
 
    
    doc.setFontSize(PDF_FONTS.SUPPLIER_NAME);
    doc.setTextColor(...PDF_COLORS.SUPPLIER_NAME);
    doc.text(`Supplier: UST`, 10, yPos);
    yPos += 12;
 
    const pillarOrder = ["Energy", "Waste", "Packaging"];
    
    pillarOrder.forEach(pillarName => {
   
        doc.setFontSize(PDF_FONTS.PILLAR_NAME);
        doc.setTextColor(...PDF_COLORS.PILLAR_NAME);
        doc.text(`Pillar: ${pillarName}`, 10, yPos);
        yPos += 10;
 
     
        doc.setFontSize(PDF_FONTS.BODY);
        doc.setTextColor(...PDF_COLORS.BODY_TEXT);
        doc.text("No data to display", 10, yPos);
        yPos += 10;
    });
 
    doc.save("supplier_goals_report.pdf");
 };

const checkAndAddNewPage = (doc, yPos, threshold = 280) => {
    if (yPos > threshold) {
        doc.addPage();
        return 20; 
    }
    return yPos;
};


const renderGoalDescriptions = (doc, descriptions, startX, startY, maxWidth) => {
    let currentY = startY;

    descriptions.forEach((description) => {

        doc.text('•', startX, currentY);

  
        const bulletIndent = 5;
        currentY = addWrappedText(doc, description, startX + bulletIndent, currentY, maxWidth - bulletIndent);
        currentY += 4; 
        currentY = checkAndAddNewPage(doc, currentY);
    });

    return currentY;
};

export const generatePDF = (data) => {
  
    const doc = new jsPDF();


    doc.setFontSize(PDF_FONTS.HEADER);
    doc.setTextColor(...PDF_COLORS.HEADER_TEXT);
    doc.setFillColor(...PDF_COLORS.HEADER_BACKGROUND);
    doc.rect(0, 0, doc.internal.pageSize.width, 30, 'F');
    doc.text("Supplier Goals", 10, 20);

    let yPos = 50;


    doc.setFontSize(PDF_FONTS.SUPPLIER_NAME);
    doc.setTextColor(...PDF_COLORS.SUPPLIER_NAME);
    doc.text(`Supplier: UST`, 10, yPos);
    yPos += 12;

    
    const pillarOrder = ["Energy", "Waste", "Packaging"];


    const groupedData = data.reduce((acc, goal) => {
        acc[goal.pillarName] = acc[goal.pillarName] || [];
        acc[goal.pillarName].push(goal);
        return acc;
    }, {});


    const orderedGroupedData = pillarOrder.reduce((ordered, pillar) => {
        if (groupedData[pillar]) {
            ordered[pillar] = groupedData[pillar];
        }
        return ordered;
    }, {});

    
    Object.entries(orderedGroupedData).forEach(([pillarName, goalsUnderPillar]) => {
        doc.setFontSize(PDF_FONTS.PILLAR_NAME);
        doc.setTextColor(...PDF_COLORS.PILLAR_NAME);
        yPos = checkAndAddNewPage(doc, yPos);
        doc.text(`Pillar: ${pillarName}`, 10, yPos);
        yPos += 10;

        
        goalsUnderPillar.forEach((goal, index) => {
            const { goalDescription, goalType, smartGoal, goalCreationYear } = goal;

        
            yPos = checkAndAddNewPage(doc, yPos);
            doc.setFontSize(PDF_FONTS.GOAL_HEADER);
            doc.setTextColor(...PDF_COLORS.GOAL_HEADER);
            doc.setFillColor(...PDF_COLORS.GOAL_HEADER_BACKGROUND);
            doc.rect(10, yPos - 5, 180, 6, "F");
            doc.text(`Goal ${index + 1}`, 10, yPos);
            yPos += 6;

          
            doc.setFontSize(PDF_FONTS.BODY);
            doc.setTextColor(...PDF_COLORS.BODY_TEXT);
            yPos += 4;

        
            yPos = renderGoalDescriptions(doc, goalDescription, 15, yPos, 180);
            yPos += 4;

          
            doc.text(`Goal Creation Year: ${goalCreationYear || "Not specified"}`, 10, yPos);
            yPos += 8;
        });
    });

    doc.save("supplier_goals.pdf");
};

export const handleDownloadPDF = async (supplierId, setLoading, setSavedData) => {
    try {
        setLoading(true);
        const response = await axios.get(`${ROUTES.GENERATE_PDF}/${supplierId}`,{
            headers:{
                Authorization:`Bearer ${sessionStorage.getItem("authToken")}`,
               'Content-Type': 'application/json'
            }
        });
        setSavedData(response.data);
        
        generatePDF(response.data);
        message.success(MESSAGES.PDF_GENERATION_SUCCESS);
    } catch (error) {
        generateEmptyPDF();
        console.error('Error fetching goals data:', error);
    } finally {
        setLoading(false);
    }
};